module.exports = __webpack_public_path__ + "assets/images/animations/ebay-animation.webp?e02ddb34";